import { forwardRef } from 'react'
import type { InputHTMLAttributes } from 'react'
import classNames from 'classnames'
import styles from './style.module.css'

export interface RadioOption {
  value: string
  label: string
}

interface RadioGroupProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'value'> {
  options: RadioOption[]
  defaultValue?: string
  ariaLabel?: string
}

const RadioGroup = forwardRef<HTMLInputElement, RadioGroupProps>(
  ({ ariaLabel, className, defaultValue, options, ...rest }, ref) => (
    <div className={classNames(styles.group, className)} role="radiogroup" aria-label={ariaLabel}>
      {options.map((option) => (
        <label key={option.value} className={styles.option}>
          <input
            type="radio"
            value={option.value}
            defaultChecked={option.value === defaultValue}
            ref={ref}
            {...rest}
          />
          <span>{option.label}</span>
        </label>
      ))}
    </div>
  ),
)

RadioGroup.displayName = 'RadioGroup'

export default RadioGroup
